type Props = React.ComponentProps<"svg"> & {
  size?: string | number;
};

const YarnIcon = ({ size = 16, ...props }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <circle cx={8} cy={8} r={6} stroke="#0E0E0E" />
      <path
        d="M7.49998 2.5C7.81167 4.35343 9.90936 8.84113 13.5 9M13.3143 5.3948C13.1896 7.24823 11.0828 11.3879 4.5 12.5M12 4C12 5.58865 9.58284 9.41135 3 11M10.2285 3.00001C10.2285 4.58866 9.08284 7.41135 2.5 9"
        stroke="#0E0E0E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default YarnIcon;
